<div class="app-label app-label__{{ type }}" [style.backgroundColor]="color">{{ text }}</div>
